export enum EnrichTab {
  JobDescription = 'job-description',
  EnrichedVersion = 'enriched-version',
  JobPreview = 'job-preview',
}

export type EnrichStepPreviewStyleProps = {
  pillIsActive?: boolean;
  sectionOverallStatus?: 'Good' | 'Low';
};

export type JobFormValues = {
  job_details: {
    job_title: string;
    employment_type: string[];
    min_salary: string;
    max_salary: string;
    salary_unit: string;
  };
  employment_requirements: {
    address: string;
    city: string;
    latitude: number | null;
    longitude: number | null;
    place_id: string | null;
    radius_km: number;
    min_working_hours: string;
    max_working_hours: string;
    shifts: string[];
    workdays: string[];
  };
  position_overview: string;
  requirements: {
    minimum_education_level: string;
    maximum_language_skills: string[];
    languages_level: string;
    certificates: string;
    drivers_license: string[];
  };
  responsibilities: string;
  compensation_and_benefits: string;
};

export type EditEnrichedVacancyProps = {};
